<template>
  <div class="container">
    <b-container class="bv-example-row">
      <b-row align-h="start">
        <b-col cols="1" offset-xl="0">
          <img
            class="title-icon"
            src="@/assets/images/company-content-title-ico.png"
          />
        </b-col>
        <b-col cols="4" offset-xl="0">
          <h3>走进益狐</h3>
          <h5>Company introduction</h5>
        </b-col>
      </b-row>
      <b-row align-h="center">
        <b-col cols="3">
          <count-to
            :start-val="0"
            :end-val="totalNum"
            :duration="3000"
            class="text-style text-center p-num"
          ></count-to>
          <p class="text-center">用户注册量</p>
        </b-col>
        <b-col cols="3">
          <count-to
            :start-val="0"
            :end-val="toadyNum"
            :duration="3000"
            :prefix="'+'"
            class="text-style text-center p-num-green"
            >+</count-to
          >
          <p class="text-center">公司注册量</p>
        </b-col>
      </b-row>
      <b-row align-h="center">
        <b-col>
          <p class="p-content">
            益狐智造科技（武汉）有限公司，成立月2016年，位于武汉经济技术开发区，由精益生产专家和软件开发工程师组成的团队。专为工厂生产现场的人员、设备、质量、物料、安全、交付等生产环节管理提供信息化、智能化解决方案。
          </p>
        </b-col>
      </b-row>
      <b-row align-h="center">
        <b-col cols="12">
          <div>
            <swiper :options="swiperOption" class="text-center div-swiper">
              <swiper-slide v-for="(slide, index) of swiperArray" :key="index">
                <img
                  class="img"
                  :src="require('../../../assets/images/' + slide + '.png')"
                />
              </swiper-slide>
              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
              <!-- <div class="swiper-pagination" slot="pagination"></div> -->
            </swiper>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import countTo from "vue-count-to";
import { userList } from "../../../api";
export default {
  name: "CompanyIntroduction",

  components: { countTo, userList },
  data() {
    return {
      totalNum: 0,
      toadyNum: 0,
      swiperArray: [
        "company-content-img1",
        // "company-content-img2",
        "company-content-img",
        "company-content-img3",
        "company-content-img4",
        "mes"
      ],
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 30,
        // slidesPerGroup: 3,
        loop: true,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        loopFillGroupWithBlank: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      }
    };
  },
  mounted() {
    this.totalNum = 10;
    this.toadyNum = 10;
    // console.log(this.totalNum);
    // console.log(this.format(0));
    // console.log(this.format(1));

    // 获取用户注册量
    userList().then(res => {
      if (res.data.code == 200) {
        let data = res.data.data;
        this.totalNum = data.user_count;
        this.toadyNum = data.company_count;
      }
    });
  },
  methods: {
    format(day) {
      var time = new Date().getTime() - 24 * 60 * 60 * 1000 * day;
      var date = new Date(time);
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentDate =
        date.getFullYear() +
        "-" +
        month +
        "-" +
        strDate +
        " " +
        date.getHours() +
        ":" +
        date.getMinutes() +
        ":" +
        date.getSeconds();
      return currentDate;
    }
  }
};
</script>

<style lang="stylus" scoped>
.title-icon {
  width: 1.3rem;
}

.h3 {
  font-size: 1.9rem;
  color: #333;
}

.h4 {
  font-size: 0.8rem;
  color: #999;
}

.p-num {
  font-size: 4.1rem;
  font-weight: 600;
}

.p-num-green {
  color: green;
  font-size: 4.1rem;
  font-weight: 600;
}

.p-content {
  font-size: 1.1rem;
  color: #999999;
}

.div-swiper {
  margin-bottom: 3rem;
}

.img {
  width: 100%;
  height: 250px;
}

.swiper-button-prev {
  // background: url('../../assets/images/company-content-swiper-prev.png');
  width: 2.8rem;
  height: 2.7rem;
}

.swiper-button-prev:before {
  background: url('../../../assets/images/company-content-swiper-prev.png');
}

.swiper-button-next {
  // background: url('@/assets/images/company-content-swiper-next.png');
  width: 2.8rem;
  height: 2.7rem;
}

.swiper-button-next:before {
  background: url('../../../assets/images/company-content-swiper-next.png');
}
</style>



// WEBPACK FOOTER //
// src/pages/company/components/ContentIntroduction.vue